import { render, staticRenderFns } from "./AccountBindVD.vue?vue&type=template&id=0926eb2c&scoped=true"
import script from "./AccountBindVD.vue?vue&type=script&lang=ts"
export * from "./AccountBindVD.vue?vue&type=script&lang=ts"
import style0 from "./AccountBindVD.vue?vue&type=style&index=0&id=0926eb2c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0926eb2c",
  null
  
)

export default component.exports